var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15,
    rx: 3,
    fill: "#153DBB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_557_452432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2529 6.81397C11.2445 7.49529 11.8408 7.87549 12.2899 8.10161C12.7507 8.33364 12.9066 8.48231 12.9048 8.68973C12.9013 9.00725 12.5365 9.14722 12.1952 9.1528C11.5999 9.16232 11.2537 8.98674 10.9785 8.85399L10.7632 9.89122C11.0393 10.0225 11.5506 10.1374 12.0808 10.1423C13.3254 10.1423 14.1397 9.50774 14.1442 8.52383C14.1491 7.2754 12.472 7.20616 12.4835 6.64807C12.4874 6.47889 12.6438 6.29839 12.9863 6.25244C13.1559 6.22931 13.6241 6.21142 14.1548 6.46396L14.3631 5.46069C14.0771 5.35337 13.7117 5.25049 13.2541 5.25049C12.0826 5.25049 11.2586 5.89374 11.2521 6.8143L11.2529 6.81397ZM16.3648 5.33746C16.2569 5.33657 16.1512 5.36907 16.0613 5.43078C15.9715 5.49249 15.9016 5.58058 15.8606 5.6837L14.0827 10.068H15.3265L15.574 9.36235H17.0936L17.2366 10.068H18.3329L17.3764 5.33664H16.3643L16.3648 5.33746ZM16.5383 6.61476L16.8972 8.3914H15.9147L16.5388 6.61476H16.5383ZM9.74343 5.33664L8.76309 10.068H9.94824L10.9287 5.33664H9.74343ZM7.9901 5.33664L6.75649 8.55697L6.25758 5.81874C6.19895 5.51304 5.96777 5.33664 5.71101 5.33664H3.69503L3.66675 5.47398C4.08081 5.5667 4.55112 5.71635 4.83601 5.87651C5.01078 5.97496 5.0602 6.0598 5.11756 6.29232L6.06263 10.068H7.31514L9.23499 5.33664H7.99074",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_557_452432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 4.8913,
    fill: "white",
    transform: "translate(3.66675 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.543deb74123fc7f2b17334bc599b8c5e.svg";
export { ForwardRef as ReactComponent };